/**
 * RN Command Center - Shared Constants and Configurations
 */

// Priority configurations
export const PRIORITY_CONFIG = {
  critical: { color: "bg-red-500", lightBg: "bg-red-50 border-red-200", textColor: "text-red-600", label: "Critical" },
  high: { color: "bg-amber-500", lightBg: "bg-amber-50 border-amber-200", textColor: "text-amber-600", label: "High" },
  medium: { color: "bg-blue-500", lightBg: "bg-blue-50 border-blue-200", textColor: "text-blue-600", label: "Medium" },
  low: { color: "bg-slate-500", lightBg: "bg-slate-50 border-slate-200", textColor: "text-slate-600", label: "Low" }
};

// Category configurations
export const CATEGORY_CONFIG = {
  overdue_tasks: { label: "Overdue Tasks", color: "text-red-500" },
  compliance_risk: { label: "Compliance Risk", color: "text-amber-500" },
  recert_due: { label: "Recert Due", color: "text-purple-500" },
  f2f_needed: { label: "F2F Needed", color: "text-blue-500" },
  decline_risk: { label: "Decline Risk", color: "text-orange-500" },
  new_admission: { label: "New Admission", color: "text-green-500" },
  symptom_alert: { label: "Symptom Alert", color: "text-pink-500" },
  visit_overdue: { label: "Visit Overdue", color: "text-red-500" },
  pain_escalation: { label: "Pain Escalation", color: "text-red-600" }
};

// Visit type configurations  
export const VISIT_TYPES = {
  routine: { label: "Routine Visit", color: "bg-blue-500" },
  prn: { label: "PRN/Symptom", color: "bg-orange-500" },
  hope_update: { label: "HOPE Update", color: "bg-purple-500" },
  wound: { label: "Wound Care", color: "bg-red-500" },
  pain: { label: "Pain Focused", color: "bg-amber-500" },
  death: { label: "Pronouncement", color: "bg-gray-500" }
};

// Visit template configurations
export const TEMPLATE_TYPES = {
  routine_visit: { label: "Routine Visit", duration: 45, sections: ["vitals", "symptom_assessment", "medication_review", "care_plan_update", "patient_education"] },
  prn_visit: { label: "PRN Visit", duration: 30, sections: ["chief_complaint", "symptom_assessment", "intervention", "outcome"] },
  death_visit: { label: "Death Visit", duration: 60, sections: ["time_of_death", "pronouncement", "family_support", "notification_checklist"] },
  admission_visit: { label: "Admission Visit", duration: 90, sections: ["comprehensive_assessment", "medication_reconciliation", "care_plan_initiation", "teaching"] },
  recert_visit: { label: "Recertification Visit", duration: 60, sections: ["comprehensive_reassessment", "loc_evaluation", "care_plan_review", "goal_update"] }
};

export const API = process.env.REACT_APP_BACKEND_URL;

export const getAuthHeaders = () => ({
  "Authorization": `Bearer ${localStorage.getItem("hospice_token")}`,
  "Content-Type": "application/json"
});
